import { useUserContext } from '../components/Providers/UserContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { LoginScreen } from '@yoda/components-core';
import { AuthType } from '../utils/utilsts';

const Welcome = () => {
  const [fullPath] = useState<string>(
    window.location.href.replace(window.location.origin, ''),
  );
  const [loginWithAzure, setLoginWithAzure] = useState(false);
  const { login, azureAPI, error, loading, addAuthType } = useUserContext();
  const navigate = useNavigate();

  const onEnterClick = () => {
    addAuthType(AuthType.IES);
    login();
  };

  const handleLoginAzure = () => {
    addAuthType(AuthType.AZURE);
    navigate('/', { replace: true });
    setLoginWithAzure(true);
  };

  if (loginWithAzure) {
    return <LoginScreen azureAPI={azureAPI} redirectTo={fullPath} />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      {loading && !error ? (
        <div style={{ textAlign: 'center' }}>
          <div>Loading...</div>
          <div style={{ marginTop: 16 }}>Setting up your session...</div>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <h1>Welcome to Tutoring Admin</h1>
          <button
            onClick={handleLoginAzure}
            style={{
              padding: '12px 32px',
              fontSize: 16,
              cursor: 'pointer',
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              marginTop: 16,
            }}
          >
            Enter with SSO
          </button>
          <button
            onClick={onEnterClick}
            style={{
              padding: '12px 32px',
              fontSize: 16,
              cursor: 'pointer',
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              marginTop: 16,
              marginLeft: 32,
            }}
          >
            Enter with IES
          </button>
          {error && (
            <div style={{ marginTop: 16, color: 'red' }}>
              <div style={{ fontWeight: 'bold' }}>Unable to Sign In</div>
              <div>
                We couldn&apos;t sign you in at the moment. Please check your connection and try
                again. If the problem continues, contact Pearson Support for assistance.
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Welcome;
